import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import BaseTable from '../../../../components/BaseTable/BaseTable.component';
import { commaFormatted } from '../../../../utils/transformer.util';

export default function Realization(props) {
  const { handleGetRealization, user } = props;
  const [state, setState] = useState([]);

  const getData = async () => {
    const data = await handleGetRealization();
    setState(data);
  }
  useEffect(() => {
    getData();
  }, [user]);

  const columns = [{
    name: 'Kode Akun',
    selector: 'code_of_account',
    sortable: true,
  }, {
    name: 'Deskripsi',
    selector: 'desc',
  }, {
    name: 'APBU',
    selector: 'ypl',
    width: '200px',
    right: true,
    sortable: true,
    cell: row => commaFormatted(row.ypl),
  }, {
    name: 'Non Anggaran',
    selector: 'non_budget',
    width: '200px',
    right: true,
    sortable: true,
    cell: row => commaFormatted(row.non_budget),
  }, {
    name: 'Realisasi',
    selector: 'utilized_budget',
    sortable: true,
    right: true,
    cell: row => commaFormatted(row.utilized_budget),
  }, {
    name: 'Persentase',
    selector: 'percentage',
    sortable: true,
    right: true,
    cell: row => `${commaFormatted(row.percentage)}%`,
  }, {
    name: 'Sisa Anggaran',
    selector: 'remains',
    sortable: true,
    right: true,
    cell: row => commaFormatted(row.remains),
  }];


  return (
    <BaseTable
      columns={columns}
      handleGet={handleGetRealization}
      data={state}
      title="Realisasi"
    />
  );
}

Realization.propTypes = {
  handleGetRealization: PropTypes.func,
  user: PropTypes.object.isRequired,
};
Realization.defaultProps = {
  handleGetRealization: noop,
};
